
import { useForm } from "react-hook-form";
import { validateRut, formatRut } from "rutlib";
import React, { useState } from "react";
import Form from "./Form";



function SignUpInfo({ formData, setFormData }) {
  const handleSelectChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  };};

export default function MiRut({ formData, setFormData }) {  


  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm();

  const [rut, setRut] = useState("");
  const validarRut = validateRut(formData.rut);
  const [formattedRut, setFormattedRut] = useState('');

  

  const onSubmit = (data, e) => {
    //e.preventDefault();

     if (validarRut === false) {
       alert("El rut ingresado no es válido");
       return;
     }

     if( validarRut === true) {
        const formattedRutt = formatRut(setRut);
        setFormattedRut(formattedRut);
       //alert("el formato es válido")
       return;
     }

    e.target.reset();
  };



  return (



   

   
   
      <form onSubmit={handleSubmit(onSubmit)}>
      <label htmlFor="rut" className="form-label">
            Rut
          </label>
        
       
        <input
          type="text"
          {...register("rut", {
            required: true,
            
            validate: (rut) => {
              if (validarRut === false) {
                const mensaje = "Formato del rut invalido";
                return mensaje;
              }
            }
          })}
          value={formData.rut}
          onChange={(e) => setFormData({ ...formData, rut: e.target.value })}
          name="rut"
          onBlur={onSubmit}
          placeholder="Rut"
        />
       

      </form>
   
   
  );
}

